import { useNavigate } from "react-router-dom";
import { ReactComponent as people } from "../../../assets/images/people.svg";
import { SideSVG } from "../../common";
import Logo from "../Logo";
import LottieAnimation from "../SuccessAnimation";
import { useEffect } from "react";
import { clearSignatoryAddress } from "../../../store/Company/companySlice";
import { useSelector, useDispatch } from "react-redux";

const Welcome = ({ status, step, onNext }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearSignatoryAddress());
    const timeout = setTimeout(() => {
      // Code to be executed after 3 seconds
      onNext();
    }, 3000);

    // Clean up the setTimeout when the component unmounts
    return () => clearTimeout(timeout);
  }, [onNext]);

  return (
    <section className="relative py-20 sm:py-0 overflow-hidden">
      <div className="px-0 mx-auto">
        <div className="mx-auto relative">
          <Logo classes="max-w-md lg:py-5 mx-auto absolute top-[-3.75rem] left-1/2 transform -translate-x-1/2 sm:left-[7rem] sm:top-5 sm:z-10" />
          <div className="flex flex-wrap -mx-4 xl:items-center">
            <div className="flex-flex1 w-full lg:w-1/2 xl:w-3/5 px-4 order-last lg:order-first">
              <div className="max-w-lg lg:py-20 mx-auto ">
                <LottieAnimation />
                <h3 className="font-heading text-h3 text-primary font-semibold mb-4 text-center">
                  {step === "onboard" && "Welcome Onboard"}
                  {step === "newcompany" && "New Business Creation Request Sent"}
                  {step === "forget" && "Password changed successfully"}
                </h3>
                {step === 'newcompany' && (
                  <p className="text-lg text-primary mb-10 text-center">
                    Your business has been successfully created
                  </p>
                )}
                {step === "onboard" && (
                  <p className="text-lg text-primary mb-10 text-center">
                    Your user profile has been successfully created
                  </p>
                )}
                {step === "forget" && (
                  <button
                    className="relative group block w-full mb-6 py-3 px-5 text-center text-sm font-semibold text-white bg-primary rounded-full overflow-hidden hover:bg-secondary"
                    onClick={() => {
                      navigate("/login");
                    }}
                  >
                    <div className="absolute top-0 right-full w-full h-full bg-primary transform group-hover:translate-x-full group-hover:scale-102 transition duration-500"></div>
                    <span className="relative">Back to login</span>
                  </button>
                )}
              </div>
            </div>
            <SideSVG SVG={people} positions="bottom-0  left-[-25%]" />

          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcome;
